import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  RadioGroup,
  Radio,
  TextField,
  Typography,
  Button,
  FormControl,
  IconButton,
  CircularProgress,
  alpha,
  Chip,
  Snackbar,
} from "@mui/material";

import {
  Add,
  Close,
  Edit,
  Error,
  NavigateBefore,
  Print,
} from "@mui/icons-material";
import useApi from "_api/index";
import RenderDetailCar from "components/Car/RenderDetailCar";
import TableData from "components/Car/Table";
import RenderConditionDetail from "components/Car/RenderConditionDetail";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import { useNavigate, useParams } from "react-router-dom";
import ModalCreateTransferAndReceiptBuy from "./FormDocuments/TransferAndReceiptBuy";
import ModalPowerOfAttorney from "./FormDocuments/PowerOfAttorney";
import ModalContractPawnCar from "./FormDocuments/ContractPawn";
import ModalContractBuyAndSell from "./FormDocuments/ContractBuyAndSell";
import ModalConsignmentCar from "./ModalConsignmentCar";
import ModalContractConsignmentCar from "./FormDocuments/ContractConsignmentCar";
import { CustomToast } from "components/Toast";
import AlertToast from "components/AlertToast";
import WatermarkedImage from "components/Pawn/WatermarkImage";

const fields = [
  {
    label: "คำนำหน้า",
    name: "customer_prefix",
    type: "text",
    required: true,
  },
  {
    label: "ชื่อ-นามสกุล",
    name: "customer_name",
    type: "text",
    required: true,
  },
  {
    label: "เลขบัตรประชาชน/ Passport No.",
    name: "customer_idcard",
    type: "text",
    required: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "customer_phonenumber",
    type: "text",
    required: true,
  },
  { label: "ที่อยู่", name: "customer_address", type: "text", required: true },
  {
    label: "สัญชาติ",
    name: "customer_nationality",
    type: "text",
    required: true,
    defaultValue: "ไทย",
  },
];

const ModalDetailCar = ({
  open,
  onClose,
  rowID,
  type,
  formlist = [],
  fetchList = null,
}) => {
  const navigate = useNavigate();

  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    open: false,
    status: "info", // 'success', 'error', 'info'
    message: "",
  });

  const [isEditDocuments, setIsEditDocuments] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const fetchDataDetail = async (rowID) => {
    try {
      setLoading(true);
      let response;
      if (type === "buy_car") {
        response = await useApi.buy_car.getCarBuyById(rowID);
      } else if (type === "ready_car") {
        response = await useApi.ready_car.getReadySellCarById(rowID);
      } else if (type === "consignment_car") {
        response = await useApi.consignment_car.getConsignmentCarById(rowID);
      } else if (type === "sold_car") {
        response = await useApi.sold_car.getSoldCarById(rowID);
      } else if (type === "pawn_car") {
        response = await useApi.pawn_car.getPawnCarById(rowID);
      } else if (type === "list_by_customer_car") {
        response = await useApi.list_by_customer_car.getListByCustomerCarById(
          rowID
        );
      } else if (type === "redeem_car") {
        response = await useApi.pawn_car.getRedeemCarById(rowID);
      } else if (type === "setting_price") {
        response = await useApi.setting_price_car.getDetailSettingPticeCarById(
          rowID
        );
      } else if (type === "repossessed_car") {
        response = await useApi.pawn_car.getRepossessedCarById(rowID);
      } else {
        throw new Error("Invalid type provided");
      }

      console.log("Fetched car details:", response);

      if (response.success && response.data) {
        setDetail(response.data);
      } else {
        setDetail(null);
        throw new Error("Failed to fetch car details");
      }
    } catch (error) {
      setDetail(null);
      console.error("Error fetching car details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (open && rowID) {
      fetchDataDetail(rowID);
    } else {
      setDetail(null);
      setLoading(true);
      setIsEditDocuments(false);
      setSelectedDocument(null);
    }
  }, [open, rowID]);

  const handlePrintPDF = async (document) => {
    console.log("Printing PDF for document:", document);
    setError({
      open: true,
      status: "info",
      message: "กำลังดาวน์โหลดเอกสาร PDF...",
    });
    let response = null;
    try {
      if (type === "buy_car") {
        if (document.document_type === "car_transform") {
          response = await useApi.buy_car.printPdfCarTransferBuy(
            document.document_id
          );
        } else if (document.document_type === "car_power_of_attorney") {
          response = await useApi.buy_car.printPdfPowerOfAttorneyBuy(
            document.document_id
          );
        } else if (document.document_type === "car_sell_contact") {
          response = await useApi.buy_car.printPdfContractBuySell(
            document.document_id
          );
        }
      } else if (type === "ready_car" || type === "sold_car") {
        if (document.document_type === "car_transform") {
          response = await useApi.ready_car.printPdfCarTransferSell(
            document.document_id
          );
        } else if (document.document_type === "car_power_of_attorney") {
          response = await useApi.ready_car.printPdfPowerOfAttorneySell(
            document.document_id
          );
        } else if (document.document_type === "car_sell_contact") {
          response = await useApi.ready_car.printPdfSellCarContract(
            document.document_id
          );
        }
      } else if (
        type === "pawn_car" ||
        type === "repossessed_car" ||
        type === "redeem_car"
      ) {
        if (document.document_type === "car_pawn_contact") {
          response = await useApi.pawn_car.printPdfCarPawnContact(
            document.document_id
          );
        } else if (document.document_type === "car_transform") {
          response = await useApi.pawn_car.printPdfCarTransferPawn(
            document.document_id
          );
        } else if (document.document_type === "car_power_of_attorney") {
          response = await useApi.pawn_car.printPdfPowerOfAttorneyPawn(
            document.document_id
          );
        }
      } else if (type === "consignment_car") {
        if (document.document_type === "car_consignment_contact") {
          response = await useApi.consignment_car.printPdfConsignmetContact(
            document.document_id
          );
        }
      }

      if (response.status == 200) {
        setError({
          open: true,
          status: "success",
          message: "ดาวน์โหลดเอกสาร PDF สำเร็จ",
        });
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(url, "_blank");
      }
    } catch (error) {
      setError({
        open: true,
        status: "error",
        message: "เกิดข้อผิดพลาดในการดาวน์โหลดเอกสาร PDF",
      });
      console.error("Error printing PDF:", error);
    }
  };

  const handleEditDocument = (document) => {
    console.log("Editing document:", document);
    console.log("detail:", detail.car);
    setSelectedDocument(document);
    setIsEditDocuments(true);
  };

  const handleSuccessDocument = () => {
    fetchDataDetail(rowID);
    fetchList && fetchList();
    setIsEditDocuments(false);
    setSelectedDocument(null);
  };

  if (!detail && !loading) {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            padding: 2,
            borderRadius: 2,
            gap: 2,
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: colors.grey[700],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            gap: 2,
          }}
        >
          <Error sx={{ fontSize: 48, color: colors.red[500] }} />
          <Typography variant="h6" color="textSecondary">
            เกิดข้อผิดพลาดในการดึงข้อมูลรถ
          </Typography>
          <Typography variant="body1" color="textSecondary">
            กรุณาลองอีกครั้งในภายหลัง
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  if (loading) {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={() => null} // ไม่ render กล่อง paper
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.5)", // ตั้งสีพื้นหลัง
          },
        }}
      >
        {/* CircularProgress วางข้างนอก */}
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1301, // สูงกว่ backdrop
          }}
        >
          <CircularProgress />
        </Box>
      </Dialog>
    );
  }

  if (isEditDocuments && selectedDocument) {
    if (type === "buy_car" || type === "ready_car" || type == "pawn_car") {
      return selectedDocument.document_type === "car_transform" ? (
        <ModalCreateTransferAndReceiptBuy
          isOpen={isEditDocuments}
          onClose={() => setIsEditDocuments(false)}
          car={detail ? detail.car : null}
          order={
            detail
              ? type === "pawn_car"
                ? {
                    order_id: detail.order_id,
                  }
                : detail.order
              : null
          }
          customer={detail ? detail.customer : null}
          document={selectedDocument?.document_id ? selectedDocument : null}
          type={
            type === "buy_car"
              ? "buy"
              : type === "ready_car"
              ? "sell_car"
              : "pawn_car"
          }
          onSuccess={() => {
            handleSuccessDocument();
          }}
        />
      ) : selectedDocument.document_type === "car_power_of_attorney" ? (
        <ModalPowerOfAttorney
          isOpen={isEditDocuments}
          onClose={() => setIsEditDocuments(false)}
          car={detail ? detail.car : null}
          order={
            detail
              ? type === "pawn_car"
                ? {
                    order_id: detail.order_id,
                  }
                : detail.order
              : null
          }
          customer={detail ? detail.customer : null}
          document={selectedDocument?.document_id ? selectedDocument : null}
          type={
            type === "buy_car"
              ? "buy"
              : type === "ready_car"
              ? "sell_car"
              : "pawn_car"
          }
          onSuccess={() => {
            handleSuccessDocument();
          }}
        />
      ) : selectedDocument.document_type === "car_pawn_contact" ? (
        <ModalContractPawnCar
          isOpen={isEditDocuments}
          onClose={() => setIsEditDocuments(false)}
          data={detail ? detail : null}
          document={selectedDocument?.document_id ? selectedDocument : null}
          onSuccess={() => {
            handleSuccessDocument();
          }}
        />
      ) : (
        <ModalContractBuyAndSell
          isOpen={isEditDocuments}
          onClose={() => setIsEditDocuments(false)}
          car={detail ? detail.car : null}
          order={detail ? detail.order : null}
          customer={detail ? detail.customer : null}
          document={selectedDocument?.document_id ? selectedDocument : null}
          type={
            type === "buy_car"
              ? "buy_car"
              : type === "ready_car"
              ? "sell_car"
              : "pawn_car"
          }
          onSuccess={() => {
            handleSuccessDocument();
          }}
        />
      );
    } else if (type === "consignment_car") {
      return (
        <ModalContractConsignmentCar
          open={isEditDocuments}
          onClose={() => setIsEditDocuments(false)}
          car={detail ? detail.car : null}
          consignment={detail ? detail.consignment_detail : null}
          order={detail ? detail.order : null}
          document={selectedDocument?.document_id ? selectedDocument : null}
          onSuccess={() => {
            handleSuccessDocument();
          }}
        />
      );
    }
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            padding: 2,
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h4">รายละเอียดรถ</Typography>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            // padding: 2,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: 8,
              height: 8,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: 4,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {detail?.customer && (
              <Box>
                <Typography variant="h5" sx={{ mb: 1 }}>
                  ข้อมูลลูกค้า
                </Typography>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    border: `1px solid ${colors.grey[300]}`,
                  }}
                >
                  <Grid container>
                    <Grid item xs={7}>
                      {fields.map((field, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          sx={{
                            m: 1,
                          }}
                          key={index}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="body1" sx={{ width: "200px" }}>
                              {field.label}
                              {field.required && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </Typography>
                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              value={detail ? detail.customer[field.name] : ""}
                              InputProps={{
                                readOnly: true,
                              }}
                              disabled
                              multiline={field.name === "customer_address"}
                              rows={field.name === "customer_address" ? 2 : 1}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  bgcolor: "white",
                                  height:
                                    field.name === "customer_address"
                                      ? "auto"
                                      : "40px",
                                  borderRadius: 2,
                                },
                              }}
                            />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                    <Grid item xs={5}>
                      <Box sx={{ padding: 1, width: "100%", height: "214px" }}>
                        {detail && detail.customer.customer_image ? (
                          <WatermarkedImage
                            src={detail.customer.customer_image}
                            alt="customer"
                            // style={{
                            //   borderRadius: 2,
                            //   width: "100%",
                            //   height: "100%",
                            // }}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#F8F7FD",
                              color: "#B0B0B0",
                              borderRadius: 2,
                            }}
                          >
                            ไม่มีรูปภาพ
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
            <RenderDetailCar car={detail.car} type={type} />
            <RenderConditionDetail
              type={type}
              loading={loading}
              data={detail}
            />
            {type !== "list_by_customer_car" && type !== "setting_price" && (
              <>
                {detail?.car?.car_status_id === 6 &&
                !detail?.car?.is_reserved ? null : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography variant="h5" sx={{ mb: 1 }}>
                      เอกสาร
                    </Typography>
                    <TableData
                      columns={[
                        { key: "document", label: "ฟอร์มเอกสาร" },
                        {
                          key: "action",
                          label: "Actions",
                          style: { textAlign: "center", width: "150px" },
                          render: (row) => {
                            const findCreated = detail
                              ? detail.documents?.some(
                                  (doc) =>
                                    doc.document_type === row.document_type
                                )
                              : false;

                            if (findCreated) {
                              return (
                                <>
                                  {detail.car.car_status_id !== 5 &&
                                    // detail.car.car_status_id !== 6 &&
                                    detail.car.car_status_id !== 7 &&
                                    type != "sold_car" &&
                                    type != "repossessed_car" && (
                                      <IconButton
                                        onClick={() =>
                                          handleEditDocument(
                                            detail.documents.find(
                                              (doc) =>
                                                doc.document_type ===
                                                row.document_type
                                            )
                                          )
                                        }
                                      >
                                        <Edit />
                                      </IconButton>
                                    )}
                                  <IconButton
                                    onClick={() =>
                                      handlePrintPDF(
                                        detail.documents.find(
                                          (doc) =>
                                            doc.document_type ===
                                            row.document_type
                                        )
                                      )
                                    }
                                  >
                                    <Print />
                                  </IconButton>
                                </>
                              );
                            } else {
                              return detail.car.car_status_id !== 5 &&
                                type !== "sold_car" ? (
                                <IconButton
                                  onClick={() => {
                                    setIsEditDocuments(true);
                                    setSelectedDocument(row);
                                  }}
                                >
                                  <Add />
                                </IconButton>
                              ) : (
                                <Chip
                                  label="ไม่มีเอกสาร"
                                  size="small"
                                  color="default"
                                />
                              );
                            }
                          },
                        },
                      ]}
                      data={
                        detail && detail?.documents?.length > 0 ? formlist : []
                      }
                      onNext={() => {
                        navigate(`/car/${type}s/form/${rowID}`);
                      }}
                      isShowNextButton={
                        type !== "ready_car" || detail?.car?.is_reserved
                      }
                      type={
                        type !== "redeem_car" &&
                        type !== "repossessed_car" &&
                        type !== "sold_car" &&
                        detail.car.car_status_id !== 5
                          ? "document"
                          : "normal"
                      }
                    />
                  </Box>
                )}
              </>
            )}

            {type === "setting_price" && detail && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h5" sx={{ mb: 1 }}>
                  ตั้งราคารถ
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          ราคาทุน
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={detail ? detail.cost_price : ""}
                          InputProps={{
                            readOnly: true,
                          }}
                          disabled
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "white",
                              height: "40px",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          ราคาขาย
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={detail ? detail.selling_price : ""}
                          InputProps={{
                            readOnly: true,
                          }}
                          disabled
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "white",
                              height: "40px",
                              borderRadius: 1,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "space-between",
            paddingx: 2,
            mt: 1,
            borderTop: `1px solid ${colors.grey[300]}`,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              borderRadius: 2,
              width: "auto",
              borderColor: colors.grey[400],
              color: colors.grey[400],
              "&:hover": {
                borderColor: colors.grey[400],
                color: colors.grey[400],
                borderWidth: 2,
                bgcolor: "transparent",
              },
            }}
          >
            <NavigateBefore
              sx={{
                width: 30,
                height: 30,
              }}
            />
          </Button>
          {type === "pawn_car" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
              }}
            >
              <GradientButtonOutline
                sx={{
                  px: 3,
                  height: "48px",
                  backgroundColor: alpha("#00BB9F", 0.2),
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: alpha("#00BB9F", 0.2),
                  },
                  border: "none",
                }}
                disableTouchRipple
              >
                ระยะเวลา {detail ? detail.total_month : "N/A"} เดือน
              </GradientButtonOutline>
              <GradientButtonOutline
                sx={{
                  px: 3,
                  height: "48px",
                  backgroundColor: alpha("#00BB9F", 0.2),
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: alpha("#00BB9F", 0.2),
                  },
                  border: "none",
                }}
                disableTouchRipple
              >
                อัตราดอกเบี้ย {detail ? detail.interest_rate : "N/A"} %
              </GradientButtonOutline>
            </Box>
          )}
          {type === "redeem_car" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
              }}
            >
              <GradientButtonOutline
                sx={{
                  px: 3,
                  height: "48px",
                  backgroundColor: alpha("#00BB9F", 0.2),
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: alpha("#00BB9F", 0.2),
                  },
                  border: "none",
                }}
                disableTouchRipple
              >
                ระยะเวลา {detail ? detail.order.total_month : "N/A"} เดือน
              </GradientButtonOutline>
              <GradientButtonOutline
                sx={{
                  px: 3,
                  height: "48px",
                  backgroundColor: alpha("#00BB9F", 0.2),
                  cursor: "default",
                  "&:hover": {
                    backgroundColor: alpha("#00BB9F", 0.2),
                  },
                  border: "none",
                }}
                disableTouchRipple
              >
                อัตราดอกเบี้ย {detail ? detail.order.interest_rate : "N/A"} %
              </GradientButtonOutline>
            </Box>
          )}
        </DialogActions>
      </Dialog>
      <AlertToast
        open={error.open}
        onClose={() => setError({ open: false, status: "info", message: "" })}
        message={error.message}
        type={error.status}
        time={3000}
      />
    </>
  );
};

export default ModalDetailCar;
